export default __webpack_public_path__ + "static/media/parked.a4125c80.svg";